export default __webpack_public_path__ + "static/media/Hendersons - Terms & Conditions.4dcc0780.b75e3b4c.pdf";